import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface ShiftInfo {
  name: string;
  timeRange: string;
}

interface ShiftTimeHintProps {
  className?: string;
}

const ShiftTimeHint: React.FC<ShiftTimeHintProps> = ({ className = '' }) => {
  const { currentTheme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  const shiftInfo: ShiftInfo[] = [
    {
      name: 'صبح',
      timeRange: '02:00 - 12:00'
    },
    {
      name: 'ظهر',
      timeRange: '12:00 - 16:00'
    },
    {
      name: 'عصر',
      timeRange: '16:00 - 20:00'
    },
    {
      name: 'شب',
      timeRange: '20:00 - 02:00'
    }
  ];

  return (
    <div onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
         className={`relative inline-block ${className}`}>
      <button
        // onClick={() => setIsVisible(!isVisible)}
        
        className="inline-flex items-center justify-center w-14 h-10 rounded text-text-tertiary hover:text-text-secondary transition-colors duration-200"
        aria-label="اطلاعات زمان شیفت‌ها"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </button>

      {/* Hint Box */}
      {isVisible && (
        <div className="absolute z-50 left-0 top-7 w-64 p-4 bg-bg-primary dark:bg-gray-800 rounded-lg shadow-lg border border-border-secondary dark:border-gray-700"
          style={{
            animation: 'fadeInScale 0.15s ease-out',
            transformOrigin: 'top right'
          }}>
          <h4 className="text-sm font-medium text-text-primary mb-3">
            ساعات شیفت‌های کاری
          </h4>
          
          <div className="space-y-2">
            {shiftInfo.map((shift, index) => (
              <div 
                key={index} 
                className="flex items-center justify-between py-1.5 text-sm"
              >
                <span className="text-text-primary">{shift.name}</span>
                <span className="font-mono text-text-secondary text-xs">
                  {shift.timeRange}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShiftTimeHint;